import {
  ILayerRepository,
  LayerEntity,
  GeometryTypeEnum,
  LayerTypeEnum,
  ResponseValueObject,
  LegendItem,
} from '@gishub/domain';
import axios from 'axios';

export class LayerRepository implements ILayerRepository {
  // 1. Define este tipo auxiliar antes de tu lista


  // 2. Usa ese tipo en tu arreglo estático
  private static readonly rawItems: (Partial<Omit<LayerEntity, 'layers'>> & { layers?: any[] })[] = [
    {
      name: "Organización político-administrativa",
      type: LayerTypeEnum.Group,
      visible: true,
      layers: [
        {
          name: "Límite departamental",
          geometryType: GeometryTypeEnum.Polygon,
          referenceSource: "MIDAGRI",
          url: "https://winlmprap09.midagri.gob.pe/winjmprap12/rest/services/DGIHR/Monitoreo_Territorial_Junin/MapServer/35",
          type: LayerTypeEnum.FeatureServer,
          visible: true,
          definitionQuery: "CODDEP LIKE '{0}%'",
          disabled: false,
          hasProxy: false,
          showLabels: true,
          popupEnabled: false,
        },
        {
          name: "Límite provincial",
          geometryType: GeometryTypeEnum.Polygon,
          referenceSource: "MIDAGRI",
          url: "https://winlmprap09.midagri.gob.pe/winjmprap12/rest/services/DGIHR/Monitoreo_Territorial_Junin/MapServer/34",
          type: LayerTypeEnum.FeatureServer,
          visible: false,
          definitionQuery: "CODPROV LIKE '{0}%'",
          disabled: false,
          hasProxy: false,
          showLabels: true,
          opacity: 0.65
        },
        {
          name: "Límite distrital",
          geometryType: GeometryTypeEnum.Polygon,
          referenceSource: "MIDAGRI",
          url: "https://winlmprap09.midagri.gob.pe/winjmprap12/rest/services/DGIHR/Monitoreo_Territorial_Junin/MapServer/33",
          type: LayerTypeEnum.FeatureServer,
          visible: false,
          definitionQuery: "UBIGEO LIKE '{0}%'",
          disabled: false,
          hasProxy: false,
          showLabels: true,
          opacity: 0.7
        },
        {
          name: "Centros poblados",
          abbreviation: "CCPP",
          displayField: "nombccpp",
          geometryType: GeometryTypeEnum.Point,
          referenceSource: "MIDIS",
          url: "https://winlmprap09.midagri.gob.pe/winjmprap12/rest/services/DGIHR/Monitoreo_Territorial_Junin/MapServer/32",
          type: LayerTypeEnum.FeatureServer,
          visible: false,
          definitionQuery: "nombdep LIKE '%{0}%'",
          definitionQueryWithLabel: true,
          disabled: false,
          hasProxy: false,
          showLabels: false,
          opacity: 0.95
        }
      ]
    },
    {
      name: "Comunidades campesinas y nativas",
      type: LayerTypeEnum.Group,
      visible: true,
      layers: [
        {
          name: "Comunidades campesinas",
          abbreviation: "CCCC",
          displayField: "nom_comunidad",
          geometryType: GeometryTypeEnum.Polygon,
          referenceSource: "MIDAGRI / GORE",
          url: "https://winlmprap09.midagri.gob.pe/winjmprap12/rest/services/DGIHR/Monitoreo_Territorial_Junin/MapServer/9",
          type: LayerTypeEnum.FeatureServer,
          visible: false,
          definitionQuery: "nom_dpto LIKE '{0}%'",
          definitionQueryWithLabel: true,
          disabled: false,
          hasProxy: false,
          showLabels: true,
          opacity: 0.65
        },
        {
          name: "Comunidades nativas",
          abbreviation: "CCNN",
          displayField: "nom_comunidad",
          geometryType: GeometryTypeEnum.Polygon,
          referenceSource: "MIDAGRI / GORE",
          url: "https://winlmprap09.midagri.gob.pe/winjmprap12/rest/services/DGIHR/Monitoreo_Territorial_Junin/MapServer/10",
          type: LayerTypeEnum.FeatureServer,
          visible: false,
          definitionQuery: "nom_dpto LIKE '{0}%'",
          definitionQueryWithLabel: true,
          disabled: false,
          hasProxy: false,
          showLabels: true,
          opacity: 0.65
        }
      ]
    },
    {
      name: "Catastro y propiedad rural",
      type: LayerTypeEnum.Group,
      visible: false,
      layers: [
        {
          name: "Predios catastrales / rurales",
          geometryType: GeometryTypeEnum.Polygon,
          referenceSource: "MIDAGRI / GORE",
          url: "https://winlmprap09.midagri.gob.pe/winjmprap12/rest/services/DGIHR/Monitoreo_Territorial_Junin/MapServer/12",
          type: LayerTypeEnum.FeatureServer,
          visible: false,
          disabled: false,
          hasProxy: false,
          showLabels: false,
          opacity: 0.6
        }
      ]
    },
    {
      "name": "Gestión social y conflictividad en Comunidades",
      "type": LayerTypeEnum.Group,
      "visible": true,
      "layers": [
        {
          name: "Espacios de diálogo (ED)",
          geometryType: GeometryTypeEnum.Polygon,
          referenceSource: "Midagri",
          url: "https://winlmprap09.midagri.gob.pe/winjmprap12/rest/services/DGIHR/Monitoreo_Territorial_Junin/MapServer/4",
          type: LayerTypeEnum.FeatureServer,
          visible: false,
          disabled: false,
          hasProxy: false,
          showLabels: false,
        },
        {
          name: "Puntos de Interés (ED)",
          geometryType: GeometryTypeEnum.Point,
          referenceSource: "Midagri",
          url: "https://winlmprap09.midagri.gob.pe/winjmprap12/rest/services/DGIHR/Monitoreo_Territorial_Junin/MapServer/3",
          type: LayerTypeEnum.FeatureServer,
          visible: true,
          disabled: false,
          hasProxy: false,
          showLabels: false,
        },
        {
          name: "Compromisos agrarios ",
          geometryType: GeometryTypeEnum.Point,
          referenceSource: "Midagri",
          url: "https://winlmprap09.midagri.gob.pe/winjmprap12/rest/services/DGIHR/Monitoreo_Territorial_Junin/MapServer/1",
          type: LayerTypeEnum.FeatureServer,
          visible: false,
          disabled: false,
          hasProxy: false,
          showLabels: false,
        },
        {
          name: "Alerta Temprana", //SOLO ES PARA DEMO posterior será reemplazado por un endpoint de alerta
          geometryType: GeometryTypeEnum.Point,
          referenceSource: "MIDAGRI",
          url: "https://winlmprap09.midagri.gob.pe/winjmprap12/rest/services/DGIHR/Monitoreo_Territorial_Junin/MapServer/2",
          type: LayerTypeEnum.FeatureServer,
          visible: false,
          filterWithGeometry: true,
          disabled: false,
          hasProxy: false,
          showLabels: false,
        }
      ]
    },
    {
      name: "Intervenciones sectoriales",
      type: LayerTypeEnum.Group,
      visible: false,
      layers: [
        {
          name: "Intervenciones sectoriales en comunidades",
          geometryType: GeometryTypeEnum.Point,
          referenceSource: "Midagri",
          url: "https://winlmprap09.midagri.gob.pe/winjmprap12/rest/services/DGIHR/Monitoreo_Territorial_Junin/MapServer/6",
          type: LayerTypeEnum.FeatureServer,
          visible: false,
          disabled: false,
          hasProxy: false,
          showLabels: false,
        },
        {
          name: "Proyecto de inversión (DGIHR)",
          geometryType: GeometryTypeEnum.Point,
          referenceSource: "MIDAGRI",
          url: "https://winlmprap09.midagri.gob.pe/winjmprap12/rest/services/DGIHR/Monitoreo_Territorial_Junin/MapServer/7",
          type: LayerTypeEnum.FeatureServer,
          visible: false,
          definitionQuery: "DPTO LIKE '%{0}%'",
          definitionQueryWithLabel: true,
          disabled: false,
          hasProxy: false,
          showLabels: false,
        }
      ]
    },
    {
      name: "Recursos naturales y ambiente",
      type: LayerTypeEnum.Group,
      visible: false,
      layers: [
        {
          name: "Ríos y quebradas",
          geometryType: GeometryTypeEnum.Line,
          referenceSource: "ANA",
          url: "https://winlmprap09.midagri.gob.pe/winjmprap12/rest/services/DGIHR/Monitoreo_Territorial_Junin/MapServer/17",
          type: LayerTypeEnum.FeatureServer,
          visible: false,
          filterWithGeometry: true,
          disabled: false,
          hasProxy: false,
          showLabels: false,
        },
        {
          name: "Cuerpos de agua",
          geometryType: GeometryTypeEnum.Polygon,
          referenceSource: "ANA",
          url: "https://geosnirh.ana.gob.pe/server/rest/services/ONRH/Cuerpos_Agua_ONRH/MapServer/37",
          type: LayerTypeEnum.FeatureServer,
          visible: false,
          filterWithGeometry: true,
          disabled: false,
          hasProxy: false,
          showLabels: false,
        },
        {
          name: "Cuencas hidrográficas",
          geometryType: GeometryTypeEnum.Polygon,
          referenceSource: "ANA",
          url: "https://winlmprap09.midagri.gob.pe/winjmprap12/rest/services/DGIHR/Monitoreo_Territorial_Junin/MapServer/18",
          type: LayerTypeEnum.FeatureServer,
          visible: false,
          filterWithGeometry: true,
          disabled: false,
          hasProxy: false,
          showLabels: false,
        },
        {
          name: "ANP (Áreas naturales protegidas)",
          geometryType: GeometryTypeEnum.Polygon,
          referenceSource: "SERNANP",
          url: "https://winlmprap09.midagri.gob.pe/winjmprap12/rest/services/DGIHR/Monitoreo_Territorial_Junin/MapServer/19",
          type: LayerTypeEnum.FeatureServer,
          visible: false,
          filterWithGeometry: true,
          disabled: false,
          hasProxy: false,
          showLabels: false,
          opacity: 0.75
        },
        {
          name: "Puntos críticos de inundación (ANA)",
          displayField: "Rio_QDA",
          geometryType: GeometryTypeEnum.Point,
          referenceSource: "ANA / SNIRH",
          url: "https://geosnirh.ana.gob.pe/server/rest/services/ONRH/Puntos_Criticos_2016_2024_STD_PC/MapServer/0",
          type: LayerTypeEnum.FeatureServer,
          visible: false,
          definitionQuery: "UPPER(Departamento) = 'JUNIN'",
          disabled: false,
          hasProxy: false,
          showLabels: false,
        },
        {
          name: "CUM (capacidad de uso mayor)",
          geometryType: GeometryTypeEnum.Polygon,
          referenceSource: "MINAM",
          url: "https://winlmprap09.midagri.gob.pe/winjmprap12/rest/services/DGIHR/Monitoreo_Territorial_Junin/MapServer/14",
          type: LayerTypeEnum.FeatureServer,
          visible: false,
          filterWithGeometry: true,
          disabled: false,
          hasProxy: false,
          showLabels: false,
          opacity: 0.55
        },
        {
          name: "Catastro Forestal - SERFOR",
          geometryType: GeometryTypeEnum.Polygon,
          referenceSource: "SERFOR",
          url: "https://winlmprap09.midagri.gob.pe/winjmprap12/rest/services/DGIHR/Monitoreo_Territorial_Junin/MapServer/16",
          type: LayerTypeEnum.FeatureServer,
          visible: false,
          disabled: false,
          hasProxy: false,
          showLabels: false,
        }
      ]
    },
    {
      name: "Fiscalización ambiental (OEFA)",
      type: LayerTypeEnum.Group,
      visible: false,
      layers: [
        {
          name: "Vertimientos de agua tratada",
          displayField: "RAZONSOCIAL",
          geometryType: GeometryTypeEnum.Point,
          referenceSource: "OEFA / PIFA",
          url: "https://pifa.oefa.gob.pe/arcgis/rest/services/OSPA/SERV_BASE_PROB/MapServer/1",
          type: LayerTypeEnum.FeatureServer,
          visible: false,
          definitionQuery: "DEPARTAMENTO = 'JUNIN'",
          disabled: false,
          hasProxy: false,
          showLabels: false,
        },
        {
          name: "Fuentes contaminantes",
          displayField: "TIPOFC",
          geometryType: GeometryTypeEnum.Point,
          referenceSource: "OEFA / PIFA",
          url: "https://pifa.oefa.gob.pe/arcgis/rest/services/OSPA/SERV_BASE_PROB/MapServer/2",
          type: LayerTypeEnum.FeatureServer,
          visible: false,
          definitionQuery: "DEPARTAMENTO = 'JUNIN'",
          disabled: false,
          hasProxy: false,
          showLabels: false,
        }
      ]
    },
    {
      name: "Infraestructura y accesibilidad",
      type: LayerTypeEnum.Group,
      visible: false,
      layers: [
        {
          name: "Red vial nacional",
          geometryType: GeometryTypeEnum.Line,
          referenceSource: "MTC",
          url: "https://winlmprap09.midagri.gob.pe/winjmprap12/rest/services/DGIHR/Monitoreo_Territorial_Junin/MapServer/21",
          type: LayerTypeEnum.FeatureServer,
          visible: false,
          definitionQuery: "DEPARTAMEN LIKE '%{0}%'",
          definitionQueryWithLabel: true,
          disabled: false,
          hasProxy: false,
          showLabels: false,
        },
        {
          name: "Red vial vecinal",
          geometryType: GeometryTypeEnum.Line,
          referenceSource: "MTC",
          url: "https://winlmprap09.midagri.gob.pe/winjmprap12/rest/services/DGIHR/Monitoreo_Territorial_Junin/MapServer/22",
          type: LayerTypeEnum.FeatureServer,
          visible: false,
          definitionQuery: "DEPARTAMEN LIKE '%{0}%'",
          definitionQueryWithLabel: true,
          disabled: false,
          hasProxy: false,
          showLabels: false,
        },
        {
          name: "Aeropuertos",
          geometryType: GeometryTypeEnum.Point,
          referenceSource: "MTC",
          url: "https://winlmprap09.midagri.gob.pe/winjmprap12/rest/services/DGIHR/Monitoreo_Territorial_Junin/MapServer/23",
          type: LayerTypeEnum.FeatureServer,
          visible: false,
          definitionQuery: "DEPARTAMENTO LIKE '%{0}%'",
          definitionQueryWithLabel: true,
          disabled: false,
          hasProxy: false,
          showLabels: false,
        },
        {
          name: "Puentes",
          geometryType: GeometryTypeEnum.Point,
          referenceSource: "MTC",
          url: "https://winlmprap09.midagri.gob.pe/winjmprap12/rest/services/DGIHR/Monitoreo_Territorial_Junin/MapServer/24",
          type: LayerTypeEnum.FeatureServer,
          visible: false,
          filterWithGeometry: true,
          disabled: false,
          hasProxy: false,
          showLabels: false,
        },
        {
          name: "Puertos",
          geometryType: GeometryTypeEnum.Point,
          referenceSource: "MTC",
          url: "https://winlmprap09.midagri.gob.pe/winjmprap12/rest/services/DGIHR/Monitoreo_Territorial_Junin/MapServer/25",
          type: LayerTypeEnum.FeatureServer,
          visible: false,
          filterWithGeometry: true,
          disabled: false,
          hasProxy: false,
          showLabels: false,
        },
        {
          name: "Presas",
          geometryType: GeometryTypeEnum.Point,
          referenceSource: "ANA",
          url: "https://winlmprap09.midagri.gob.pe/winjmprap12/rest/services/DGIHR/Monitoreo_Territorial_Junin/MapServer/15",
          type: LayerTypeEnum.FeatureServer,
          visible: false,
          definitionQuery: "NOMBDEP LIKE '%{0}%'",
          definitionQueryWithLabel: true,
          disabled: true,
          hasProxy: false,
          showLabels: false,
        },
      ]
    },
    {
      name: "Suelo agropecuario",
      type: LayerTypeEnum.Group,
      visible: false,
      layers: [
        {
          name: "Superficie agrícola",
          geometryType: GeometryTypeEnum.Polygon,
          referenceSource: "MIDAGRI",
          url: "https://winlmprap09.midagri.gob.pe/winlmprap14/rest/services/ideMidagri/DGESEP/MapServer/2",
          type: LayerTypeEnum.MapServer,
          visible: false,
          definitionQuery: "IDDIST LIKE '{0}%'",
          disabled: true,
          hasProxy: false,
          showLabels: false,
          opacity: 0.65
        }
      ]
    },
    {
      name: "Actividad minera y energética",
      type: LayerTypeEnum.Group,
      visible: true,
      layers: [
        {
          name: "Concesiones mineras",
          geometryType: GeometryTypeEnum.Polygon,
          referenceSource: "INGEMMET",
          url: "https://winlmprap09.midagri.gob.pe/winjmprap12/rest/services/DGIHR/Monitoreo_Territorial_Junin/MapServer/29",
          type: LayerTypeEnum.FeatureServer,
          visible: false,
          definitionQuery: "DEPA LIKE '%{0}%'",
          definitionQueryWithLabel: true,
          disabled: false,
          hasProxy: false,
          showLabels: false,
          opacity: 0.65
        },
        {
          name: "Unidades mineras / minas",
          geometryType: GeometryTypeEnum.Point,
          referenceSource: "MINEM",
          url: "https://winlmprap09.midagri.gob.pe/winjmprap12/rest/services/DGIHR/Monitoreo_Territorial_Junin/MapServer/30",
          type: LayerTypeEnum.FeatureServer,
          visible: false,
          definitionQuery: "REGION LIKE '%{0}%'",
          definitionQueryWithLabel: true,
          disabled: false,
          hasProxy: false,
          showLabels: false,
        }
      ]
    },
    {
      name: "Servicios sociales y equipamiento",
      type: LayerTypeEnum.Group,
      visible: false,
      layers: [
        {
          name: "Escuelas MINEDU",
          geometryType: GeometryTypeEnum.Point,
          referenceSource: "MINEDU",
          url: "https://geocatmin.ingemmet.gob.pe/arcgis/rest/services/SERV_OTRAS_FUENTES/MapServer/29",
          type: LayerTypeEnum.MapServer,
          visible: false,
          definitionQuery: "UBIGEO LIKE '{0}%'",
          disabled: false,
          hasProxy: true,
          showLabels: false,
        },
        {
          name: "Centro de Salud - MINSA",
          geometryType: GeometryTypeEnum.Point,
          referenceSource: "MINSA",
          url: "https://winlmprap09.midagri.gob.pe/winjmprap12/rest/services/DGIHR/Monitoreo_Territorial_Junin/MapServer/27",
          type: LayerTypeEnum.FeatureServer,
          visible: false,
          definitionQuery: "DEPARTAMEN LIKE '%{0}%'",
          definitionQueryWithLabel: true,
          disabled: false,
          hasProxy: false,
          showLabels: false,
        }
      ]
    },
  ];

  async getAll(): Promise<ResponseValueObject<LayerEntity[]>> {
    const items: LayerEntity[] = LayerRepository.rawItems
      .map(item => {
        if (item.layers) {
          const activeLayers = item.layers
            .filter(sub => !sub.disabled)
            .map(sub => new LayerEntity(sub));
          if (activeLayers.length === 0) return null;
          return new LayerEntity({ ...item, layers: activeLayers });
        }
        if (item.disabled) return null;
        return new LayerEntity(item);
      })
      .filter((x): x is LayerEntity => x != null);
    return new ResponseValueObject(true, items);
  }

  async getGeolocationLayers(): Promise<ResponseValueObject<LayerEntity[]>> {
    const all = await this.getAll();
    if (!all.success || !all.data) {
      return new ResponseValueObject(false, []);
    }
    const geoLayers: LayerEntity[] = [];
    for (const item of all.data) {
      if (item.layers) {
        for (const sub of item.layers) {
          if (sub.definitionQuery && sub.abbreviation) {
            geoLayers.push(sub);
          }
        }
      } else {
        if (item.definitionQuery && item.abbreviation) {
          geoLayers.push(item);
        }
      }
    }
    return new ResponseValueObject(true, geoLayers);
  }

  async getLayerMetadata(url: string): Promise<ResponseValueObject<any>> {
    try {
      const response = await axios.get(url, {
        params: { f: 'json' },
        timeout: 10_000,
      });
      return new ResponseValueObject(true, response.data);
    } catch (ex: any) {
      return new ResponseValueObject(false, null, ex.message);
    }
  }

  /**
   * Obtiene los ítems de leyenda de un endpoint ArcGIS /legend?f=json.
   * @param legendUrl URL ya resuelta (directa o con proxy) construida por el notifier.
   * @param sublayerId ID del sub-layer a filtrar (opcional; si se omite devuelve todos).
   */
  async getLegend(legendUrl: string, sublayerId?: string): Promise<ResponseValueObject<LegendItem[]>> {
    try {
      const response = await axios.get<{ layers?: { layerId: number; legend: LegendItem[] }[] }>(
        legendUrl,
        { timeout: 10_000 }
      );
      const layers = response.data?.layers ?? [];
      let items: LegendItem[];

      if (sublayerId !== undefined) {
        const match = layers.find(l => l.layerId?.toString() === sublayerId);
        items = match?.legend ?? [];
      } else {
        items = layers.flatMap(l => l.legend ?? []);
      }

      return new ResponseValueObject(true, items, undefined, []);
    } catch (ex: any) {
      return new ResponseValueObject(false, [], ex.message);
    }
  }

}


